import React from "react";
import {Container, LoadingCenter, Text} from "../../../ui";
import {Dialog} from "../../bounce-ui";
import {ContactMethodType, UserCommunicationPreferences} from "../../declarations";
import {FormValidations} from "../../helpers";
import {ContactMethod} from "./components/ContactMethod";

interface ContactMethodsContentProps {
  communicationPreferences?: UserCommunicationPreferences;
  smsChecked: boolean;
  emailChecked: boolean;
  phoneCallChecked: boolean;
  whatsappChecked: boolean;
  aiCallsChecked: boolean;
  voicemailChecked: boolean;
  smsValue: string;
  emailValue: string;
  phoneCallValue: string;
  whatsappValue: string;
  aiCallsValue: string;
  voicemailValue: string;
  submitHandler: () => Promise<void>;
  contactMethodCheckedHandler: (type: ContactMethodType, checked: boolean) => void;
  editValueHandler: (type: ContactMethodType, value: string) => void;
  partnerName: string;
}

const ContactMethodsContent: React.FC<ContactMethodsContentProps> = ({
  communicationPreferences,
  smsChecked,
  emailChecked,
  phoneCallChecked,
  whatsappChecked,
  aiCallsChecked,
  voicemailChecked,
  smsValue,
  emailValue,
  phoneCallValue,
  whatsappValue,
  aiCallsValue,
  voicemailValue,
  submitHandler,
  contactMethodCheckedHandler,
  editValueHandler,
  partnerName,
}) => {
  return (
    <Dialog title={"Manage your contact methods"} buttonText={"Approve"} onClick={submitHandler}>
      <Container fullWidth sx={{overflow: "auto", gap: "8px", height: "280px"}}>
        {!communicationPreferences ? (
          <LoadingCenter />
        ) : (
          <>
            <ContactMethod
              type={"SMS"}
              title={"By SMS"}
              value={FormValidations.convertInternationalIntoUSFormat(smsValue) || ""}
              checked={smsChecked}
              onCheckedChange={contactMethodCheckedHandler}
              onEditValue={editValueHandler}
            />
            <ContactMethod
              type={"email"}
              title={"By Email"}
              value={emailValue}
              checked={emailChecked}
              onCheckedChange={contactMethodCheckedHandler}
              onEditValue={editValueHandler}
            />
            <ContactMethod
              type={"phone_call"}
              title={"By Phone Call"}
              value={FormValidations.convertInternationalIntoUSFormat(phoneCallValue) || ""}
              checked={phoneCallChecked}
              onCheckedChange={contactMethodCheckedHandler}
              onEditValue={editValueHandler}
            />
            <ContactMethod
              type={"whatsapp"}
              title={"By WhatsApp"}
              value={FormValidations.convertInternationalIntoUSFormat(whatsappValue) || ""}
              checked={whatsappChecked}
              onCheckedChange={contactMethodCheckedHandler}
              onEditValue={editValueHandler}
            />
            <ContactMethod
              type={"ai_calls"}
              title={"By AI Call"}
              value={FormValidations.convertInternationalIntoUSFormat(aiCallsValue) || ""}
              checked={aiCallsChecked}
              onCheckedChange={contactMethodCheckedHandler}
              onEditValue={editValueHandler}
            />
            <ContactMethod
              type={"voicemail"}
              title={"By Voicemail"}
              value={FormValidations.convertInternationalIntoUSFormat(voicemailValue) || ""}
              checked={voicemailChecked}
              onCheckedChange={contactMethodCheckedHandler}
              onEditValue={editValueHandler}
            />
          </>
        )}
      </Container>
      <Text size={12}>
        {`By approving, you consent to being contacted by ${partnerName} via the selected communication channels
        regarding your account.`}
      </Text>
    </Dialog>
  );
};

export default ContactMethodsContent;
